'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = require('react-intl');

var Locale = (0, _reactIntl.defineMessages)({
  unauthorized: {
    'id': 'core.unauthorized',
    'defaultMessage': 'Unauthorized.'
  },
  not_found: {
    'id': 'core.not_found',
    'defaultMessage': 'Not found.'
  },
  conflict: {
    'id': 'core.conflict',
    'defaultMessage': 'Conflict.'
  },
  close: {
    'id': 'core.close',
    'defaultMessage': 'Close'
  },
  cancel: {
    'id': 'core.cancel',
    'defaultMessage': 'Cancel'
  },
  notification: {
    'id': 'core.notification',
    'defaultMessage': 'Notification'
  },
  ok: {
    'id': 'core.ok',
    'defaultMessage': 'Ok'
  },
  dismiss: {
    'id': 'core.dismiss',
    'defaultMessage': 'Dismiss'
  },
  red: {
    'id': 'core.red',
    'defaultMessage': 'Red'
  },
  orange: {
    'id': 'core.orange',
    'defaultMessage': 'Orange'
  },
  yellow: {
    'id': 'core.yellow',
    'defaultMessage': 'Yellow'
  },
  pink: {
    'id': 'core.pink',
    'defaultMessage': 'Pink'
  },
  purple: {
    'id': 'core.purple',
    'defaultMessage': 'Purple'
  },
  lightPurple: {
    'id': 'core.lightPurple',
    'defaultMessage': 'Light Purple'
  },
  blue: {
    'id': 'core.blue',
    'defaultMessage': 'Blue'
  },
  lightBlue: {
    'id': 'core.lightBlue',
    'defaultMessage': 'Light Blue'
  },
  green: {
    'id': 'core.green',
    'defaultMessage': 'Green'
  },
  lightGreen: {
    'id': 'core.lightGreen',
    'defaultMessage': 'Light Green'
  },
  lightGray: {
    'id': 'core.lightGray',
    'defaultMessage': 'Light Gray'
  },
  darkGray: {
    'id': 'core.darkGray',
    'defaultMessage': 'Dark Gray'
  },
  today: {
    'id': 'core.today',
    'defaultMessage': 'TODAY'
  },
  all: {
    'id': 'core.all',
    'defaultMessage': 'All'
  },
  selectAll: {
    'id': 'core.selectAll',
    'defaultMessage': 'Select all'
  },
  menu: {
    'id': 'core.menu',
    'defaultMessage': 'Menu'
  },
  pager: {
    'id': 'core.pager',
    'defaultMessage': '{currentPage} of {totalPages}'
  },
  search_field: {
    'id': 'core.search_field',
    'defaultMessage': 'Search...'
  },
  filter_field: {
    'id': 'core.filter_field',
    'defaultMessage': 'Filter...'
  }
});

exports.default = Locale;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/Locale.js
// module id = 48
// module chunks = 10